"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageRemoteAuthenticatorSettings = void 0;
var _react = _interopRequireDefault(require("react"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsRemoteAuthenticatorSettings = require("../../components/DmsAuthenticatorsSettings/DmsRemoteAuthenticatorSettings");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPageRemoteAuthenticatorSettings Component
 * 
 * @description Component for managing remote authenticator settings within the system.
 * Renders a DmsPage layout with a DmsAltBox containing the DmsRemoteAuthenticatorSettings component.
 * 
 * @component
 * @example
 * return (
 *   <DmsPageRemoteAuthenticatorSettings />
 * )
 * 
 * @returns {JSX.Element} The Remote Authenticator Settings page.
 */
const DmsPageRemoteAuthenticatorSettings = () => {
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Remote Authenticator Settings"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("RemoteAuthenticatorSettings").d("Remote Authenticator Settings"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsRemoteAuthenticatorSettings.DmsRemoteAuthenticatorSettings, null))));
};
exports.DmsPageRemoteAuthenticatorSettings = DmsPageRemoteAuthenticatorSettings;